import { render, staticRenderFns } from "./JourneyBrickOctagon.vue?vue&type=template&id=3f190f69&scoped=true&"
import script from "./JourneyBrickOctagon.vue?vue&type=script&lang=js&"
export * from "./JourneyBrickOctagon.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-brick-octagon.scss?vue&type=style&index=0&id=3f190f69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f190f69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f190f69')) {
      api.createRecord('3f190f69', component.options)
    } else {
      api.reload('3f190f69', component.options)
    }
    module.hot.accept("./JourneyBrickOctagon.vue?vue&type=template&id=3f190f69&scoped=true&", function () {
      api.rerender('3f190f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBrickOctagon.vue"
export default component.exports